const POST_LOGIN_REDIRECT_KEY = "gw-post-login-redirect"
const POST_LOGIN_REDIRECT_TTL_MS = 10 * 60 * 1000

interface StoredRedirect {
  target: string
  ts: number
}

export function safeRedirectPath(raw: string | null | undefined): string | null {
  if (!raw) {
    console.log("[deeplink] safeRedirectPath: empty input →", raw)
    return null
  }
  if (!raw.startsWith("/") || raw.startsWith("//") || raw.startsWith("/\\")) {
    console.log("[deeplink] safeRedirectPath: rejected →", raw)
    return null
  }
  console.log("[deeplink] safeRedirectPath: ok →", raw)
  return raw
}

export function writeStoredRedirect(target: string) {
  if (typeof window === "undefined") return
  try {
    const payload: StoredRedirect = { target, ts: Date.now() }
    localStorage.setItem(POST_LOGIN_REDIRECT_KEY, JSON.stringify(payload))
    console.log("[deeplink] writeStoredRedirect: wrote", payload)
  } catch (e) {
    console.log("[deeplink] writeStoredRedirect: failed", e)
  }
}

export function readStoredRedirect(): string | null {
  if (typeof window === "undefined") return null
  try {
    const raw = localStorage.getItem(POST_LOGIN_REDIRECT_KEY)
    console.log("[deeplink] readStoredRedirect: raw localStorage value →", raw)
    if (!raw) return null
    const parsed = JSON.parse(raw) as StoredRedirect
    console.log("[deeplink] readStoredRedirect: parsed →", parsed)
    if (!parsed.target || typeof parsed.ts !== "number") {
      console.log("[deeplink] readStoredRedirect: invalid shape")
      return null
    }
    const age = Date.now() - parsed.ts
    if (age > POST_LOGIN_REDIRECT_TTL_MS) {
      console.log("[deeplink] readStoredRedirect: expired (age ms)", age)
      localStorage.removeItem(POST_LOGIN_REDIRECT_KEY)
      return null
    }
    console.log("[deeplink] readStoredRedirect: ok →", parsed.target, "age ms", age)
    return parsed.target
  } catch (e) {
    console.log("[deeplink] readStoredRedirect: parse error", e)
    return null
  }
}

export function clearStoredRedirect() {
  if (typeof window === "undefined") return
  try {
    const before = localStorage.getItem(POST_LOGIN_REDIRECT_KEY)
    localStorage.removeItem(POST_LOGIN_REDIRECT_KEY)
    console.log("[deeplink] clearStoredRedirect: cleared (was)", before)
    console.trace("[deeplink] clearStoredRedirect: stack")
  } catch {}
}
